import API, { responseOf } from "./base";
import type { ApiKey } from "../model/ApiKey";

export const getAll = (userId: string): Promise<ApiKey[]> =>
  responseOf(API.get(`/api-keys/byUserId/${userId}`));

export const create = (name: string): Promise<string> =>
  responseOf(API.post("/api-keys", {}, { params: { name } }));

export const revokeByName = async (name: string): Promise<void> => {
  await API.post(`/api-keys/revokeByName/${name}`);
};

export const elevate = (): Promise<string> =>
  responseOf(API.post("/api-keys/elevate-cm-user"));
